import React from 'react';
import { Form } from '@tribeplatform/react-components/Form';
import { T, useStaticIntl } from '@tribeplatform/react-components/i18n';
import { Accordion } from '@tribeplatform/react-ui-kit/Accordion';
import { useBlock } from '../../hooks/index.js';
import { directionTitlesFactory, paddingTitlesFactory, sizeTitlesFactory, } from './constants.js';
const normalizePadding = padding => {
    var _a, _b;
    if (typeof padding === 'undefined')
        padding = 'md';
    if (typeof padding === 'string') {
        return {
            horizontal: {
                size: padding,
                disableOnMobile: false,
            },
            vertical: {
                size: padding,
                disableOnMobile: false,
            },
        };
    }
    if (!((_a = padding) === null || _a === void 0 ? void 0 : _a.horizontal) &&
        !((_b = padding) === null || _b === void 0 ? void 0 : _b.vertical)) {
        return {
            horizontal: Object.assign({}, padding),
            vertical: Object.assign({}, padding),
        };
    }
    return Object.assign({
        horizontal: {
            size: 'none',
            disableOnMobile: false,
        },
        vertical: {
            size: 'none',
            disableOnMobile: false,
        },
    }, padding);
};
export const ContainerBlockSettings = () => {
    var _a, _b, _c, _d;
    const { block, upsertProp } = useBlock();
    const { props: { size, direction, spacing, padding }, } = block;
    const paddingObject = normalizePadding(padding);
    const paddingTitles = useStaticIntl(paddingTitlesFactory);
    const sizeTitles = useStaticIntl(sizeTitlesFactory);
    const directionTitles = useStaticIntl(directionTitlesFactory);
    return (React.createElement(Form, { defaultValues: {
            size,
            direction,
            padding: paddingObject,
            spacing,
            'padding.vertical.size': (_b = (_a = paddingObject) === null || _a === void 0 ? void 0 : _a.vertical) === null || _b === void 0 ? void 0 : _b.size,
            'padding.horizontal.size': (_d = (_c = paddingObject) === null || _c === void 0 ? void 0 : _c.horizontal) === null || _d === void 0 ? void 0 : _d.size,
        } }, ({ watch }) => {
        const [verticalPadding, horizontalPadding] = watch(['padding.vertical.size', 'padding.horizontal.size']);
        return (React.createElement("div", { className: "flex flex-col space-y-5" },
            React.createElement(Form.Select, { name: "size", label: React.createElement(T, { id: "Generics.Size", defaultMessage: "Size" }), items: sizeTitles, onChange: value => {
                    upsertProp('size', value);
                }, helperText: React.createElement(T, { id: "Blocks.Container.SizeHelperText", defaultMessage: "We use 4-columns grid system. Different sizes defines how many columns this container should take." }) }),
            React.createElement(Form.Select, { name: "direction", label: React.createElement(T, { id: "Generics.Direction", defaultMessage: "Direction" }), items: directionTitles, onChange: value => {
                    upsertProp('direction', value);
                }, helperText: React.createElement(T, { id: "Blocks.Container.DirectionHelperText", defaultMessage: "Defines how blocks inside the container should be aligned." }) }),
            React.createElement(Form.Select, { name: "spacing", label: React.createElement(T, { id: "Generics.Spacing", defaultMessage: "Spacing" }), items: paddingTitles, onChange: value => {
                    upsertProp('spacing', value);
                }, helperText: React.createElement(T, { id: "Blocks.Container.SpacingHelperText", defaultMessage: "Spacing between blocks inside the container." }) }),
            React.createElement(Accordion, { className: "-mx-2", variant: "plus", iconAlign: "trailing" },
                React.createElement(Accordion.Button, null,
                    React.createElement(T, { id: "Blocks.Container.PaddingsSectionTitle", defaultMessage: "Paddings" })),
                React.createElement(Accordion.Panel, null,
                    React.createElement("div", { className: "flex flex-col space-y-5" },
                        React.createElement(Form.Select, { name: "padding.vertical.size", label: React.createElement(T, { id: "Blocks.Container.VerticalPaddingLabel", defaultMessage: "Vertical padding" }), items: paddingTitles, onChange: value => {
                                paddingObject.vertical.size = value;
                                upsertProp('padding', Object.assign({}, paddingObject));
                            } }),
                        verticalPadding !== 'none' && (React.createElement(Form.Checkbox, { name: "padding.vertical.disableOnMobile", label: React.createElement(T, { id: "Blocks.Container.SkipVerticalPaddingLabel", defaultMessage: "Skip vertical padding on mobile" }), onChange: e => {
                                paddingObject.vertical.disableOnMobile =
                                    !!e.target.checked;
                                upsertProp('padding', Object.assign({}, paddingObject));
                            } })),
                        React.createElement(Form.Select, { name: "padding.horizontal.size", label: React.createElement(T, { id: "Blocks.Container.HorizontalPaddingLabel", defaultMessage: "Horizontal padding" }), items: paddingTitles, onChange: value => {
                                paddingObject.horizontal.size = value;
                                upsertProp('padding', Object.assign({}, paddingObject));
                            } }),
                        horizontalPadding !== 'none' && (React.createElement(Form.Checkbox, { name: "padding.horizontal.disableOnMobile", label: React.createElement(T, { id: "Blocks.Container.SkipHorizontalPaddingLabel", defaultMessage: "Skip horizontal padding on mobile" }), onChange: e => {
                                paddingObject.horizontal.disableOnMobile =
                                    !!e.target.checked;
                                upsertProp('padding', Object.assign({}, paddingObject));
                            } })))))));
    }));
};
//# sourceMappingURL=Settings.js.map